import { Receipt } from 'lucide-react';
import { data, dinheiro, nomePessoa, textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';
import { discretoAtivo } from '../../nucleo/discreto';

/** Lista de 30/10 (item 10): despesas (descrição e funcionário). A lista lê `?busca=`: o item abre com a descrição. */
interface DespesaBusca {
  id: string;
  descricao: string;
  funcionario_nome: string | null;
  data: string;
  valor_centavos: number;
  moeda?: string;
}

const lista = (busca: string) => (busca ? `${caminhoDaAba('despesas', 'despesas')}?busca=${encodeURIComponent(busca)}` : `${caminhoDaAba('despesas', 'despesas')}`);

// Rodada rl30-2 (VIS-M2): com o modo discreto, o item não leva o texto do registro para a busca da lista (ficaria por extenso no
// campo e no endereço); a lista abre sem filtro. O "Ver todos" segue com o termo que a própria pessoa digitou.
export const buscaDespesas: FonteBuscaGlobal[] = [
  {
    chave: 'despesas',
    permissao: 'despesas.ver',
    pagina: 'despesas.despesas',
    grupo: 'buscaGlobal.despesas',
    posicao: 78,
    icone: Receipt,
    item: (d: DespesaBusca) => ({
      id: d.id,
      rotulo: textoLivre(d.descricao, d.funcionario_nome),
      detalhe: [nomePessoa(d.funcionario_nome), data(d.data), dinheiro(d.valor_centavos, d.moeda)].filter(Boolean).join(' · '),
      link: discretoAtivo() ? lista('') : lista(d.descricao),
    }),
    verTodos: lista,
  },
];
